<template>
  <div class="home wrapper">
    <div class="wk_home_intro">
      <div class="wk_intro__row_left">
        <h1 class="wk_intro__title">Welcome in Abet Toolkit</h1>
      </div>
      <div class="wk_intro__row_right">
        <div class="wk_login_container">
          <h2>Sign in to Abet Toolkit</h2>

          <v-form
              ref="form"
              v-model="valid"
              class="wk_local_login"
              @submit.prevent="localLogin"
          >
            <div class="field_label_container">
              <span class="field_label">Username</span>
            </div>
            <v-text-field
                v-model="user.username"
                class="wk_input_field"
                variant="outlined"
            ></v-text-field>

            <div class="field_label_container">
              <span class="field_label">Password</span>
              <span class="forgot" @click="dialog = true;">Forgot?</span>
            </div>
            <v-text-field
                v-model="user.password"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                class="wk_input_field"
                variant="outlined"
                @click:append-inner="showPassword = !showPassword"
            ></v-text-field>

            <div class="wk_login_warning" v-show="showError">
              Username and password are not valid.
            </div>

            <button
                type="submit"
                class="login_button"
                :disabled="!user.username || !user.password"
            >Sign in</button>
          </v-form>


          <div class="wk_login_divider">
            <span>Login for Abet Laminati users</span>
            <span class="line"></span>
          </div>

          <div class="wk_microsoft_login_container">
            <button class="microsoft_button" @click="login">
              <img
                  src="../../public/img/microsoft-logo.svg"
                  alt="Microsoft Logo"
                  class="microsoft_logo"
              />
              Sign in with Azure AD
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <v-dialog
      class="wk_forgot_password_dialog"
      v-model="dialog"
      max-width="500px"
      close-on-back
  >
    <div class="wk_forgot_password_overlay">
      <h2>Forgot your password?</h2>
      <p>Please contact your Abet representative to reset your password.</p>
    </div>
  </v-dialog>
</template>

<style lang="scss">
/** Microsoft official style
.wk_microsoft_login_container {
  font-family: "Segoe UI", sans-serif;
  font-style: normal;
  font-size: 16px;
  color: #5e5e5e;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  transition: color 0.3s ease;
}

.microsoft_button {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid #8c8c8c;
  transition: background-color 0.3s ease;
}
*/

.wk_microsoft_login_container {
  font-family: "Segoe UI", sans-serif;
  font-style: normal;
  font-size: 16px;

  width: 100%;
  margin: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  color: #5e5e5e;
  transition: color 0.3s ease;
}

.microsoft_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 10px 20px;

  background-color: #ffffff;
  border: 1px solid #000000;
  border-radius: 10px;

  transition: background-color 0.3s ease;
  cursor: pointer;
}

.microsoft_button:hover {
  color: #ffffff;
  background-color: #005a9e;
}

.microsoft_logo {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.wrapper {
  width: 90%;
  margin: 0 auto;
  max-width: 1280px;
}

.home.wrapper {
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
}

.wk_home_intro {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

h1.wk_intro__title {
  font-size: 40px;
  font-weight: 800;
}

.wk_intro__row_right,
.wk_intro__row_left {
  width: 50%;
  align-content: center;
}

.wk_login_divider {
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  z-index: 2;

  span {
    position: relative;
    padding: 0 10px;
    font-size: 0.875rem;
    z-index: 2;
    background-color: white;
  }

  .line {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    border-top: 1px solid #7B7B7B;
    z-index: 1;
  }
}

.wk_login_container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;

  width: 100%;
  max-width: 500px;
  height: auto;

  border: 1px solid black;
  border-radius: 10px;

  padding: 50px 3rem;
  margin: 0 auto;

  h2 {
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .wk_local_login {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
  }

  .field_label_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.25rem;

    .field_label {
      font-weight: bold;
    }

    .forgot {
      font-size: 0.875rem;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .wk_input_field {
    width: 100%;
    border-radius: 10px;

    .v-field {
      border-radius: 10px !important;
      border-color: black !important;
    }
  }

  .login_button {
    width: 100%;
    min-height: 50px;
    background-color: black;
    color: white;
    border: 1px solid #767676;
    padding: 10px 20px;
    border-radius: 10px;
    transition: background-color 0.3s ease, color 0.3s ease;

    &:hover {
      background-color: white;
      color: black;
    }
  }

  .login_button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;

    background-color: black;
    color: white;
  }
}

.wk_heading_3 {
  color: black;
  font-weight: 400;
  font-size: 30px;
  line-height: 1.3em;
}

.wk_login_warning {
  margin-bottom: 20px;
  font-size: 0.75rem;
  color: #D32F2F;
}

.wk_forgot_password_overlay {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 2rem;

  border: 1px solid black;
  border-radius: 10px;
  background-color: white;

  h2 {
    font-size: 1.5rem;
    font-weight: bold;
  }
}
</style>

<script>
import axios from "axios";
import {API_URL} from "@/utils/const";
import authHeader from "@/services/data.service";
import {mapGetters} from "vuex";

export default {
  name: "login",
  data() {
    return {
      user: {
        username: null,
        password: null,
      },
      authError: "",
      showError: false,
      valid: false,
      showPassword: false,
      visible: false,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["loggedIn"])
  },
  methods: {
    async login() {
      this.loading = true;

      this.$store
          .dispatch("auth/login", { provider: "msal" })
          .then(() => {
            this.$store
                .dispatch("auth/token")
                .then(() => {
                  Promise.resolve(axios
                      .get(API_URL + `auth/login`, {headers: authHeader()}));
                  Promise.resolve(this.$store.dispatch("auth/role"));
                });
            this.$router.push({path: "/"});
          })
          .catch(() => {
            this.loading = false;
          });
    },
    async localLogin() {
      this.loading = true;

      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      this.$store
          .dispatch("auth/login", { provider: "local", credentials: this.user })
          .then(() => {
            this.$router.push({path: "/"});
          }).catch((error) => {
            if (error.response && error.response.status === 404) {
              this.authError = "Invalid username or password."
            } else {
              this.authError = "Authentication failed. Please try again."
            }
            this.showError = true;
          });

      this.loading = false;

    }
  },
  mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    }

    if (this.loggedIn) {
      this.$router.push({ path: "/" });
    }
  },
};
</script>
